import { useEffect, useState } from 'react';
import {
    Box,
    Grid,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import CircularProgress from '@mui/material/CircularProgress';
import { MessageTypeConstants } from '../../../../services/bot/Message';
import { processSendMessage } from '../../../../services/bot/conversation/SendMessage';
import { uuidGenerator } from '../../../../utils/general';
import { getAuthData } from '../../../../services/storage/LocalStorage';
import { ImagePath } from '../../../../assets/ImagePath';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchLoader } from '../../../../state/actions/loader';
import { debounce } from 'lodash';
import { showToast } from '../../../ui/toaster';

const SearchComponent = ({
    options = {},
    parentDocId,
    parentTabId,
    isOnline,
    setSearchValue,
    searchValue,
    setShouldShowClrIcon,
    shouldShowClrIcon,
    handleAction = () => {},
}) => {

    const searchLoader = useSelector((state) => state.loader.searchLoader);
    const dispatch = useDispatch();
    const { user = {} } = getAuthData();
    const defaultUserTimezone = 'Etc/UTC';

    // const isValidSearch = (value) => {
    //     const trimmedValue = value.trim();

    //     // Regex patterns:
    //     const alphaNumPattern = /^[a-zA-Z0-9\s]{2,}$/; // current pattern
    //     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // basic email validation
    //     const phonePattern = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/; // common phone formats

    //     return (
    //         alphaNumPattern.test(trimmedValue) ||
    //         emailPattern.test(trimmedValue) ||
    //         phonePattern.test(trimmedValue)
    //     );
    // };

    useEffect(() => {
        if (options) {
            dispatch(setSearchLoader(false));
        }
    }, [options]);

    useEffect(() => {
        return () => {
            debouncedSearch?.cancel();
        };
    }, []);

    const onSubmit = (e) => {
        if (e.key === 'Enter' && e.target.value !== '') {
            const input = e.target.value;
            // if (!isValidSearch(input)) {
            //     showToast('error', `The entered value is not valid. Please enter a valid search term.`);
            //     dispatch(setSearchLoader(false));
            //     return;
            // }

            dispatch(setSearchLoader(true));
            const messageObj = {
                messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
                message: {
                    controlId: options.controlId,
                    tabId: options?.parent?.length || options.sectionId ? parentTabId : options.tabId,
                    sectionId: options.sectionId || null,
                    parentDocId,
                    action: 'search',
                    queryString: input,
                    tz: user?.userTimezone || defaultUserTimezone,
                },
                messageId: uuidGenerator(),
            };

            if (options.style === "map") {
                delete messageObj.message.parentDocId;
                delete messageObj.message.sectionId;
            }

            processSendMessage(messageObj);
        }
    };

    const onClear = (e) => {
        handleAction("clearSearch", null, null, null, null, true);
        setSearchValue('');
        setShouldShowClrIcon(false);
        e.stopPropagation();
    };

    const debouncedSearch = debounce((value) => {
        dispatch(setSearchLoader(true));

        // if (!isValidSearch(value)) {
        //     showToast('error', `The entered value is not valid. Please enter a valid search term.`);
        //     dispatch(setSearchLoader(false));
        //     return;
        // }

        const messageObj = {
            messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
            message: {
                controlId: options.controlId,
                tabId: options?.parent?.length || options.sectionId ? parentTabId : options.tabId,
                sectionId: options.sectionId || null,
                parentDocId,
                action: 'search',
                queryString: value,
                tz: user?.userTimezone || defaultUserTimezone,
            },
            messageId: uuidGenerator(),
        };

        if (options.style === "map") {
            delete messageObj.message.parentDocId;
            delete messageObj.message.sectionId;
        }

        processSendMessage(messageObj);
    }, 500);

    
    const onChange = (e) => {
        const value = e.target.value;
        setSearchValue(value);
        setShouldShowClrIcon(!!value);

        // if (value.length === 0) {
        //     handleAction("clearSearch", null, null, null, null, true);
        //     debouncedSearch.cancel();
        // } else {
        //     debouncedSearch(value);
        // }
    };

    const handleSendClick = () => {
        const input = searchValue.trim();
        if (input !== '') {
            // if (!isValidSearch(input)) {
            //     showToast('error', `The entered value is not valid. Please enter a valid search term.`);
            //     dispatch(setSearchLoader(false));
            //     return;
            // }

            dispatch(setSearchLoader(true));
            const messageObj = {
                messageType: MessageTypeConstants.MESSAGE_TYPE_TABLE_RESPONSE,
                message: {
                    controlId: options.controlId,
                    tabId: options?.parent?.length || options.sectionId ? parentTabId : options.tabId,
                    sectionId: options.sectionId || null,
                    parentDocId,
                    action: 'search',
                    queryString: input,
                    tz: user?.userTimezone || defaultUserTimezone,
                },
                messageId: uuidGenerator(),
            };

            if (options.style === "map") {
                delete messageObj.message.parentDocId;
                delete messageObj.message.sectionId;
            }

            processSendMessage(messageObj);
        }
    };

    return (
        <Grid>
            <Box className="relative search">
                <input
                    className="px-9 h-[32px] w-full border border-gray-100 rounded-10 shadow-shd-on text-size-14 outline-none placeholder:text-dark-3 placeholder:text-[14px] pr-14"
                    placeholder={options.searchPlaceholder || 'Search'}
                    value={searchValue}
                    disabled={!isOnline}
                    onChange={onChange}
                    onKeyDown={onSubmit}
                    style={{ opacity: isOnline ? 1 : 0.5 }}
                />

                {/* Search Icon */}
                <img
                    src={ImagePath.searchIcon}
                    alt="search"
                    className="absolute top-[8px] left-3 pointer-events-none"
                    style={{ opacity: isOnline ? 1 : 0.5 }}
                />

                {/* Right side icons */}
                <div className={`absolute ${!searchValue.trim() ? 'top-4' : 'top-2'} right-2 flex items-center gap-2`}>
                    {searchLoader ? (
                        <div className="flex items-center justify-center referesh-icon">
                            <CircularProgress className='!w-[12px] !h-[12px]'  />
                        </div>
                    ) : shouldShowClrIcon ? (
                        <ClearIcon
                            className="search-clear-icon cursor-pointer text-gray-500 hover:text-gray-700"
                            fontSize="small"
                            onClick={onClear}
                        />
                    ) : null}

                    {searchValue.trim() && (
                        <img
                            src={ImagePath.sendbtn}
                            alt="send"
                            className="cursor-pointer"
                            onClick={handleSendClick}
                        />
                    )}
                </div>
            </Box>
        </Grid>
    );
};

export default SearchComponent;
